module.exports = "./img/04b38b4293d8bd5f1828916ac18b6dc2.jpg";